import { withAntePostBasedMarketTemplateModelSelectors } from '@swf/sports/models/market-templates/antePostBased';

import { defaultState } from './defaultState';

export const selectors = withAntePostBasedMarketTemplateModelSelectors(defaultState, (slice) => ({
  hasPreloaded: () => slice((state) => state.hasPreloaded),
  isLoading: () => slice((state) => state.isLoading),
  hasErrored: () => slice((state) => state.errorCode),
  templateGroups: () => slice((state) => state.templateGroups)
}));
